import {makeStyles, Theme} from '@material-ui/core'

const cellPaddingAdjustStyle: Record<string, any> = {
  paddingRight: 8,
  paddingLeft: 8,
  '&:last-child': {
    paddingRight: 8
  }
}

export const useCommonTableStyles = makeStyles((theme: Theme) => ({
  tableHeader: {
    backgroundColor: theme.palette.grey[50]
  },
  tableHeaderCell: {
    ...theme.typography.caption,
    ...cellPaddingAdjustStyle,
    color: theme.palette.grey[700]
  },
  tableRow: {
    '&:last-child > td': {
      borderBottom: 0
    }
  },
  tableRowCell: {
    ...cellPaddingAdjustStyle,
    borderBottomColor: theme.palette.grey[100]
  },
  cellBorder: {
    borderRightColor: theme.palette.grey[100],
    borderRightStyle: 'solid',
    borderRightWidth: 1,
    '&:last-child': {
      borderRight: 0
    }
  },
  alwaysCellBorder: {
    borderRightColor: theme.palette.grey[100],
    borderRightStyle: 'solid',
    borderRightWidth: 1
  },
  cell: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&:last-child': {
      paddingRight: theme.spacing(2)
    }
  },
  headerCell: {
    cursor: 'pointer',
    position: 'relative'
  }
}))
